import store from "@/store/index";

export default [
    {
        path: "*",
        name: "notfound",
        component: () => import("@/components/security/_Login.vue"),
        meta: {
            title: "login.signIn"
        }
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/components/security/_Login.vue"),
        meta: {
            title: "login.signIn"
        }
    },
    {
        path: "/resetpassword",
        name: "resetpassword",
        component: () => import("@/components/security/_ResetPassword.vue"),
        meta: {
            title: "navbar.resetPassword"
        }
    },
    {
        path: "/createnewpassword",
        name: "createnewpassword",
        component: () => import("@/components/security/_ResetPassword.vue"),
        beforeEnter: async (to: any, from: any, next: any) => {
            try {
                const isloggedIn: Boolean = store.getters["authentication/isLoggedIn"];
                if (isloggedIn) {
                    store.dispatch("authentication/logoutAction", to.query.t);
                }
                next();
            } catch (e) {
                next({ path: "/" });
            }
        },
        meta: {
            title: "navbar.resetPassword"
        }
    },
    {
        path: "/oneTimeLogin",
        name: "oneTimeLogin",
        component: () => null,
        beforeEnter: async (to: any, from: any, next: any) => {
            try {
                const result = await store.dispatch("authentication/adminLoginAction", to.query.t);
                if (result.status === 200) {
                    next({ path: "/" });
                }
            } catch (e) {
                next({ path: "/login" });
            }
        }
    }
];
